exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-row[data-v-0a4194a6]{margin-bottom:20px;&:last-child{margin-bottom:0}}.el-col[data-v-0a4194a6]{border-radius:4px}.grid-content[data-v-0a4194a6]{border-radius:5px;min-height:130px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#f2faff;opacity:.94;font-size:16px;font-weight:bolder}.addBtn[data-v-0a4194a6]{padding:10px 0}.item-title[data-v-0a4194a6]{font-size:16px;font-weight:bolder}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a4194a6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/count/customer/try.vue
// module id = 1739
// module chunks = 0